import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

// styles
import './SearchForm.css'

// convert segment to value for sorting purposes 
// e.g 5-1 -> 501 
const segmentToValue = (segment) => (parseInt(segment.split('-')[0]) * 100 + parseInt(segment.split('-')[1]))

export default function SearchForm({ data, particle: searchedParticle, particleType: searchedParticleType, minKaiwaSegment: searchedMinKaiwaSegment, maxKaiwaSegment: searchedMaxKaiwaSegment }) {
    const [particle, setParticle] = useState('')
    const [particleType, setParticleType] = useState('')

    // get unique kaiwa segments to populate min/max segment selectors
    // e.g. 1-1, 1-2, 1-3 ...
    let uniqueKaiwaSegments = Array.from(new Set(data.map((d) => d.kaiwa_segment)))
    let sortedUniqueKaiwaSegments = uniqueKaiwaSegments.sort((a, b) => segmentToValue(a) - segmentToValue(b))
    console.log(sortedUniqueKaiwaSegments)
    const [minKaiwaSegment, setMinKaiwaSegment] = useState(sortedUniqueKaiwaSegments[0])
    const [maxKaiwaSegment, setMaxKaiwaSegment] = useState(sortedUniqueKaiwaSegments[sortedUniqueKaiwaSegments.length - 1])
    console.log(maxKaiwaSegment)

    // set search fields to the searched values if exists
    useEffect(() => {
        searchedParticle ? setParticle(searchedParticle) : setParticle('')
        // set default to kakari
        searchedParticleType ? setParticleType(searchedParticleType) : setParticleType('all-words')
    }, [searchedParticle, searchedParticleType])

    useEffect(() => {
        if (searchedMinKaiwaSegment) { setMinKaiwaSegment(searchedMinKaiwaSegment) }
        if (searchedMaxKaiwaSegment) { setMaxKaiwaSegment(searchedMaxKaiwaSegment) }
    }, [searchedMinKaiwaSegment, searchedMaxKaiwaSegment])

    // on form submit, navigate to search results
    const navigate = useNavigate()
    const handleSubmit = (e) => {
        e.preventDefault()
        navigate(`/search?q=${particle}&t=${particleType}&min=${minKaiwaSegment}&max=${maxKaiwaSegment}`)
    }

    return (
        <div className='main-query-box container'>
            <div className='row justify-content-center'>
                <div className='col' id='all-input-div'>
                    <form id='inputform' onSubmit={handleSubmit}>
                        <div className='row'>
                            <p className='d-inline fs-7 fw-bold col-auto mt-1' style={{ width: "100px" }}>選択項目</p>
                            <div className='col-md-auto'>

                                <div className="btn-group p-0" role="group" id="particle-selector-group">
                                    <input
                                        type="radio"
                                        className="btn-check"
                                        name="particle-choice"
                                        id="all-words"
                                        checked={particleType === "all-words"}
                                        value='all-words'
                                        onChange={(e) => setParticleType(e.target.id)}
                                    />
                                    <label className="btn btn-outline-secondary" htmlFor="all-words">語彙</label>
                                    <input
                                        type="radio"
                                        className="btn-check"
                                        name="particle-choice"
                                        id="kakari"
                                        checked={particleType === "kakari"}
                                        value='kakari'
                                        onChange={(e) => setParticleType(e.target.id)}
                                    />
                                    <label className="btn btn-outline-secondary" htmlFor="kakari">係助詞</label>
                                    <input
                                        type="radio"
                                        className="btn-check"
                                        name="particle-choice"
                                        id="teidai"
                                        checked={particleType === "teidai"}
                                        value='teidai'
                                        onChange={(e) => setParticleType(e.target.id)}
                                    />
                                    <label className="btn btn-outline-secondary" htmlFor="teidai">提題助詞</label>
                                    <input
                                        type="radio"
                                        className="btn-check"
                                        name="particle-choice"
                                        id="kaku"
                                        checked={particleType === "kaku"}
                                        value='kaku'
                                        onChange={(e) => setParticleType(e.target.id)}
                                    />
                                    <label className="btn btn-outline-secondary" htmlFor="kaku">格助詞</label>
                                    <input
                                        type="radio"
                                        className="btn-check"
                                        name="particle-choice"
                                        id="sentence-final"
                                        checked={particleType === "sentence-final"}
                                        value="sentence-final"
                                        onChange={(e) => setParticleType(e.target.id)}
                                    />
                                    <label className="btn btn-outline-secondary" htmlFor="sentence-final">終助詞</label>
                                    <input
                                        type="radio"
                                        className="btn-check"
                                        name="particle-choice"
                                        id="setsuzoku"
                                        checked={particleType === "setsuzoku"}
                                        value='setsuzoku'
                                        onChange={(e) => setParticleType(e.target.id)}
                                    />
                                    <label className="btn btn-outline-secondary" htmlFor="setsuzoku">接続助詞</label>
                                    <input
                                        type="radio"
                                        className="btn-check"
                                        name="particle-choice"
                                        id="juntai"
                                        checked={particleType === "juntai"}
                                        value='juntai'
                                        onChange={(e) => setParticleType(e.target.id)}
                                    />
                                    <label className="btn btn-outline-secondary" htmlFor="juntai">準体助詞</label>
                                </div>

                            </div>
                        </div>
                        <div className='row'>
                            <p className='d-inline fs-7 fw-bold col-auto mt-1' style={{ width: "100px" }}></p>
                            <div className='col-md-7 extra-message-container'>
                                {
                                    particleType === 'all-words' &&
                                    <p className='extra-message'>
                                        名詞、副詞、接続詞、感嘆詞などが検索できます。
                                    </p>
                                }
                                {
                                    particleType === 'kakari' &&
                                    <p className='extra-message'>
                                        係助詞には､通常の｢どぅ｣｢が｣を含めています｡　連体形との呼応のある副詞｢あんし｣は語彙の方から検索可能です｡
                                    </p>
                                }
                                {
                                    particleType === 'teidai' &&
                                    <p className='extra-message'>
                                        提題助詞の｢ん｣(=｢も｣)と｢や｣(=｢は｣)は､前方母音との融合形(｢にん｣｢ぬん｣や｢ねー｣｢のー｣｢ぇ/えー｣など)
                                        で現れる場合が多いですが､前者は｢ん｣､後者は｢―｣/｢や｣で検索可能です｡
                                    </p>
                                }
                                {
                                    particleType === 'kaku' &&
                                    <p className='extra-message'>
                                        格助詞には､｢が｣｢ぬ｣(主格/連体格/目的)､｢かい/んかい/なかい｣｢うぅてぃ/うぅとーてぃ/んじ｣(場所)､ 
                                        ｢から｣(起点)､｢までぃ｣(終点)､｢に｣(時間)､｢とぅ｣「とぅか」(共起)､｢やか｣(比較)､｢し｣｢さーに｣(道具)などを含めています｡
                                    </p>
                                }
                                {
                                    particleType === 'sentence-final' &&
                                    <p className='extra-message'>
                                        終助詞は､｢どー｣｢よー｣｢やー｣｢てー｣｢でー｣｢さ｣｢っさー｣(情報領域・情報源)､
                                        ｢い/み/に｣｢が｣｢がやー｣｢なー｣｢ふー｣「ひー/いー」(自･他問提示)｢ひゃー｣｢(えー)さに｣｢しぇー｣ (話者態度)
                                        ｢な｣(禁止)､｢よー｣｢まー(に)｣(命令)､｢でぃ/んでぃ｣(引用)､｢たい/さい(敬意)などが含まれます｡間投助詞用法も含めています｡
                                    </p>
                                }
                                {
                                    particleType === 'setsuzoku' &&
                                    <p className='extra-message'>
                                        接続助詞は､｢くとぅ/ぐとぅ｣(順接)､｢しが｣(逆接)､｢むん(ぬ)/むぬ｣(順接･逆接)を取り扱い､
                                        仮定形の助詞は含めていません｡
                                    </p>
                                }
                                {
                                    particleType === 'juntai' &&
                                    <p className='extra-message'>
                                        準体助詞は、「し」(=「の」)を扱っています。
                                    </p>
                                }
                            </div>

                        </div>

                        <div className='row'>
                            <p className='d-inline fs-7 fw-bold col-auto mt-1' style={{ width: "100px" }}>検索範囲</p>
                            <div className='kaiwa-segment-selector col-auto'>
                                <select
                                    className="form-select"
                                    value={minKaiwaSegment}
                                    onChange={(e) => setMinKaiwaSegment(e.target.value)}
                                >
                                    {sortedUniqueKaiwaSegments && sortedUniqueKaiwaSegments.map((seg) => {
                                        if (segmentToValue(seg) <= segmentToValue(maxKaiwaSegment)) {
                                            return <option key={seg} value={seg}>{seg}</option>
                                        }
                                        return ''
                                    })}
                                </select>
                            </div>
                            <p className='col-auto align-middle mt-2 px-0'><small>ー</small></p>
                            <div className='kaiwa-segment-selector col-auto'>
                                <select
                                    className="form-select"
                                    value={maxKaiwaSegment}
                                    onChange={(e) => setMaxKaiwaSegment(e.target.value)}
                                >
                                    {sortedUniqueKaiwaSegments && sortedUniqueKaiwaSegments.map((seg) => {
                                        if (segmentToValue(seg) >= segmentToValue(minKaiwaSegment)) {
                                            return <option key={seg} value={seg}>{seg}</option>
                                        }
                                        return ''
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className='row'>
                            <p className='col-auto align-middle mt-2' style={{ width: "100px" }}><small><strong>キーワード</strong></small></p>
                            <div className='col-auto'>
                                <label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        name="particle"
                                        placeholder="単数(A), 複数(A/B)"
                                        value={particle || ''}
                                        onChange={(e) => setParticle(e.target.value)}
                                    />
                                </label>
                            </div>
                            <div className='col-auto'>
                                <button className='btn btn-primary'>検索</button>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </div >

    )
}
